var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"place"},[_c('main-content',{attrs:{"right-sidebar":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }